import { Link } from "react-router-dom";
import { getImageUrl } from "./ProductCard";

export function FeaturedCardsRow({ section }) {
  const cards = section.featuredCards || [];
  if (!cards.length) return null;

  return (
    <section className="container mx-auto px-4 lg:px-8 py-10">
      {section.title && (
        <h2 className="text-2xl sm:text-4xl font-display font-bold text-center text-foreground mb-8">
          {section.title}
        </h2>
      )}
      {section.subtitle && (
        <p className="text-center text-muted-foreground mb-8">{section.subtitle}</p>
      )}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6">
        {cards.map((card, idx) => {
          const inner = (
            <div className="group rounded-2xl overflow-hidden flex flex-col h-full border border-border bg-surface hover:border-primary/40 hover:shadow-card-hover transition-all">
              {/* Text block: fixed padding, consistent across cards */}
              <div className="p-4 sm:p-5">
                <h3 className="text-base sm:text-lg font-bold text-foreground truncate">{card.title}</h3>
                {card.subtitle && (
                  <p className="text-xs sm:text-sm text-muted-foreground mt-1 line-clamp-1">
                    {card.subtitle}
                  </p>
                )}
              </div>
              {/* Logo well: uniform white box + fixed height so transparent and
                  white-background logos look identical regardless of source. */}
              <div className="mt-auto flex h-32 sm:h-36 items-center justify-center bg-white p-4">
                {card.image ? (
                  <img
                    src={getImageUrl(card.image)}
                    alt={card.title}
                    className="max-h-full max-w-[75%] object-contain group-hover:scale-105 transition-transform"
                    loading="lazy"
                  />
                ) : (
                  <div className="w-24 h-12 rounded bg-muted" />
                )}
              </div>
            </div>
          );

          if (card.link) {
            const isExternal = card.link.startsWith("http");
            return isExternal ? (
              <a key={idx} href={card.link} target="_blank" rel="noopener noreferrer">
                {inner}
              </a>
            ) : (
              <Link key={idx} to={card.link}>
                {inner}
              </Link>
            );
          }
          return <div key={idx}>{inner}</div>;
        })}
      </div>
    </section>
  );
}
